import React, { useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import {
  Switch,
  Input,
  Select,
  Button,
  message,
  Card,
  Form,
  Tag,
} from 'antd';
import { getBanner, updateBanner } from '../../services/Admin';

const TYPE_OPTIONS = [
  { value: 'info', label: 'Info', color: 'blue' },
  { value: 'warning', label: 'Warning', color: 'orange' },
  { value: 'error', label: 'Error', color: 'red' },
];

function Announcements() {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  const { isLoading } = useQuery(
    ['getBanner'],
    getBanner,
    {
      onSuccess: (data) => {
        form.setFieldsValue({
          enabled: data.enabled,
          message: data.message,
          type: data.type,
        });
      },
    },
  );

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      setSaving(true);
      await updateBanner(values);
      queryClient.invalidateQueries(['getBanner']);
      message.success('Banner updated');
    } catch {
      message.error('Failed to update banner');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div id="Announcements" style={{ maxWidth: 600 }}>
      <Card title="Banner Announcement" loading={isLoading}>
        <Form
          form={form}
          layout="vertical"
          initialValues={{ enabled: false, message: '', type: 'info' }}
        >
          <Form.Item
            name="enabled"
            label="Enabled"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
          <Form.Item
            name="message"
            label="Message"
            rules={[{ required: true, message: 'Message is required' }]}
          >
            <Input.TextArea rows={3} placeholder="Banner message shown to all users" />
          </Form.Item>
          <Form.Item
            name="type"
            label="Type"
            rules={[{ required: true, message: 'Type is required' }]}
          >
            <Select>
              {TYPE_OPTIONS.map((opt) => (
                <Select.Option key={opt.value} value={opt.value}>
                  <Tag color={opt.color} style={{ marginRight: 4 }}>{opt.label}</Tag>
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item>
            <Button type="primary" onClick={handleSave} loading={saving}>
              Save
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}

Announcements.propTypes = {};

export default Announcements;
